export enum SvcRcaStatus {
  Opened = 10,
  Closed = 20,
  Canceled = 30,
}

export const SvcRcaStatusTyped = {
  10: 'opened',
  20: 'completed',
  30: 'closed',
};

export enum SvcRcaStatusDescription {
  Opened = 'Aberto',
  Closed = 'Encerrado',
  Canceled = 'Cancelado',
}

export enum SvcRcaCustomFieldsFeatureName {
  RcaType = 'rca-type',
}

export enum SvcModalRcaUserRole {
  Administrator = '93A73F21-E228-4EEA-B6A8-A5B35DE894FA',
}

export enum SvcModalRcaStepType {
  ProblemDefinition = 1,
  ImmediateActionPlans = 2,
  ProcessVerification = 3,
  ProbableCauses = 4,
  RootCauses = 5,
  ActionPlans = 6,
  EffectivenessEvaluation = 7,
  StandardizationReplication = 8,
}

export enum SvcModalRcaAdditionalReferenceId {
  ActionPlan = 1,
  ImmediateActionPlan = 2,
  WhyWhy = 3,
}

export enum SvcModalRcaFinalizeErrors {
  RootCauseNotFilled = 'Por favor, selecione ao menos uma causa raiz.',
  ActionPlansIncomplete = 'Para finalizar um RCA 1-pager é necessário adicionar pelo menos 1 (um) plano de ação e finalizá-lo.',
}

export enum SvcRcaComment {
  ConfigType = '141D2ECD-5E08-4D60-9875-24A66613147E',
}

export enum SvcModalRcaCallbacks {
  EventName = 'rcaModalAngularCallback',
  Create = 'CreateRcaCallback',
  Update = 'UpdateRcaCallback',
  Delete = 'DeleteRcaCallback',
  Cancel = 'CancelRcaCallback',
  Finish = 'FinishRcaCallback',
}

export enum SvcModalRcaTab {
  CauseAnalysis = 0,
  Feed = 1,
}
